import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TableList, TextButton, useOverlayContext } from 'seagull';
import { useStore } from '~/contexts';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { EditMode, NotificationSettingsEntryType } from '~/models/NotificationSettingsModel';
import { selectors } from '~/store/state-selectors';
import { EditNotificationSettingsModal } from './EditNotificationSettingsModal';
import { getNotificationsToShow, Table } from './NotificationSettings.utils';
import styles from './NotificationSettingsTable.module.scss';
const typeMap = {
    [Table.Reminders]: NotificationSettingsEntryType.Recurring,
    [Table.Notifications]: NotificationSettingsEntryType.Single
};
export const NotificationSettingsTable = (param)=>{
    let { data, tableType, columnDefs, selectedTab, headerItems, refresh, getRowItems } = param;
    const featureFlags = useFeatureFlags();
    const overlayContext = useOverlayContext();
    const showKarbonIntegration = useStore(selectors.integration.showKarbonIntegration);
    const showClientHubIntegration = useStore(selectors.integration.showClientHubIntegration);
    const showFinancialCentsIntegration = useStore(selectors.integration.showFinancialCentsIntegration);
    const showKeeperIntegration = useStore(selectors.integration.showKeeperIntegration);
    const notificationsTextMap = getNotificationsToShow({
        tab: selectedTab,
        showKarbonIntegration,
        showClientHubIntegration,
        showFinancialCentsIntegration,
        showKeeperIntegration,
        featureFlags
    });
    const handleEditClick = (props)=>{
        overlayContext.showModal({
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(EditNotificationSettingsModal, _object_spread({
                    selectedTab: selectedTab,
                    dismissModal: dismissModal
                }, props));
            }
        });
    };
    return /*#__PURE__*/ _jsxs(TableList.Provider, {
        columnDefs: columnDefs,
        hasActionColumn: true,
        children: [
            /*#__PURE__*/ _jsx(TableList.Header, {
                items: headerItems,
                testId: "".concat(tableType, "-table-header"),
                className: styles.header
            }),
            Object.entries(notificationsTextMap).map((param)=>{
                let [key, text] = param;
                const notification = data[selectedTab][key];
                return notification && notification.type === typeMap[tableType] && /*#__PURE__*/ _jsx(TableList.Row, {
                    size: "fluid",
                    items: getRowItems({
                        notification,
                        text,
                        key
                    }),
                    testId: "".concat(tableType, "-row-").concat(key),
                    className: styles.row,
                    actionColumn: notification.editMode === EditMode.Enabled && /*#__PURE__*/ _jsx(TextButton, {
                        onClick: ()=>handleEditClick({
                                tableType,
                                notification,
                                notificationText: text,
                                notificationName: key,
                                refresh
                            }),
                        underline: "none",
                        testId: "".concat(tableType, "-row-").concat(key, "-edit"),
                        children: "Edit"
                    })
                }, key);
            })
        ]
    });
};
